import { actionCreator } from 'utils';
import * as DiscountTypes from '../types/discountTypes';

// A D D   N E W   D I S C O U N T
export function addNewDiscount(data) {
    return {
        type: DiscountTypes.ADD_NEW_DISCOUNT,
        data,
    };
}

export function addNewDiscountRes(success) {
    return {
        type: actionCreator(DiscountTypes.ADD_NEW_DISCOUNT, 'res'),
        success,
    };
}

export function addNewDiscountErr(error) {
    return {
        type: actionCreator(DiscountTypes.ADD_NEW_DISCOUNT, 'err'),
        error,
    };
}
// A D D   N E W   D I S C O U N T


// U P D A T E   T R A N S L A T E   D I S C O U N T
export function updateTranslateDiscount(key) {
    return {
        type: DiscountTypes.UPDATE_TRANSLATE_DISCOUNT,
        key,
    };
}

export function updateTranslateDiscountRes(key, loading, success) {
    return {
        type: actionCreator(DiscountTypes.UPDATE_TRANSLATE_DISCOUNT, 'res'),
        key,
        loading,
        success,
    };
}

export function updateTranslateDiscountErr(key) {
    return {
        type: actionCreator(DiscountTypes.UPDATE_TRANSLATE_DISCOUNT, 'err'),
        key,
    };
}
// U P D A T E   T R A N S L A T E   D I S C O U N T


// L O A D   D I S C O U N T S
export function loadDiscounts() {
    return {
        type: DiscountTypes.LOAD_DISCOUNTS,
    };
}

export function loadDiscountsRes(data) {
    return {
        type: actionCreator(DiscountTypes.LOAD_DISCOUNTS, 'res'),
        data,
    };
}

export function loadDiscountsErr() {
    return {
        type: actionCreator(DiscountTypes.LOAD_DISCOUNTS, 'err'),
    };
}
// L O A D   D I S C O U N T S


// S E T   D I S C O U N T   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T
export function setDiscountFilters(key, value) {
    return {
        type: DiscountTypes.SET_DISCOUNT_FILTER,
        key,
        value,
    };
}

export function setDiscountPagination(key, pagination) {
    return {
        type: DiscountTypes.SET_DISCOUNT_PAGINATION,
        key,
        pagination,
    };
}

export function setDiscountSort(sort) {
    return {
        type: DiscountTypes.SET_DISCOUNT_SORT,
        sort,
    };
}

export function resetDiscountFilters() {
    return {
        type: DiscountTypes.RESET_DISCOUNT_FILTERS,
    };
}
// S E T   D I S C O U N T   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T


// L O A D   E D I T A B L E   D I S C O U N T
export function loadEditableDiscount(id) {
    return {
        type: DiscountTypes.LOAD_EDITABLE_DISCOUNT,
        id,
    };
}

export function loadEditableDiscountRes(data) {
    return {
        type: actionCreator(DiscountTypes.LOAD_EDITABLE_DISCOUNT, 'res'),
        data,
    };
}

export function loadEditableDiscountErr(error) {
    return {
        type: actionCreator(DiscountTypes.LOAD_EDITABLE_DISCOUNT, 'err'),
        error,
    };
}

export function setEmptyEditableDiscount() {
    return {
        type: DiscountTypes.SET_EMPTY_EDITABLE_DISCOUNT,
    };
}
// L O A D   E D I T A B L E   D I S C O U N T


// E D I T   D I S C O U N T
export function editDiscount(data) {
    return {
        type: DiscountTypes.EDIT_DISCOUNT,
        data,
    };
}

export function editDiscountRes(success) {
    return {
        type: actionCreator(DiscountTypes.EDIT_DISCOUNT, 'res'),
        success,
    };
}

export function editDiscountErr(error) {
    return {
        type: actionCreator(DiscountTypes.EDIT_DISCOUNT, 'err'),
        error,
    };
}
// E D I T   D I S C O U N T
